import { render, staticRenderFns } from "./AddUserPage.vue?vue&type=template&id=3ff9c772&scoped=true&"
import script from "./AddUserPage.vue?vue&type=script&lang=js&"
export * from "./AddUserPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff9c772",
  null
  
)

export default component.exports